import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';
import { Flex, Box } from 'rebass';

import Image from '../Image/Image';
import Link from '../../base/Link/Link';

import { theme } from '../../styles/theme';
import animationSettings from '../../styles/animationSettings';
import { TeamMemberStoryblok } from '../../types/storyblok';
import { Type } from '../../base/Type/Type';

const StyledImage = styled(Image)`
  height: 55vw;
  max-height: calc(1400px / 5);

  @media (min-width: ${theme.breakpoint.md}) {
    height: 30vw;
  }

  @media (min-width: ${theme.breakpoint.lg}) {
    height: 20vw;
  }
`;

const HoverLink = styled(Link)`
  ${(props) =>
    props.animationSettings.teamMemberCardHover &&
    css`
      .portrait {
        filter: grayscale(100%);
        transition: 0.4s ease-in-out;
      }

      &:hover {
        .portrait {
          filter: grayscale(0%);
          transform: scale(1.05);
        }
      }
    `}
`;

const TeamMemberCard = ({
  name,
  description,
  link,
  image,
  photo,
}: TeamMemberStoryblok) => {
  let useGatsbyImage = !image;
  if (useGatsbyImage) {
    image = getImage(photo.images.slice(-1)[0]); // last element should be the most recent
  }

  // Assume link is a linkedin ID if doesn't look like a URL
  if (link && !link.startsWith('http')) {
    link = `https://www.linkedin.com/in/${link}`;
  }

  return (
    <HoverLink animationSettings={animationSettings} href={link}>
      <Flex flexWrap="wrap">
        <Box width={1} flexGrow="2">
          {image && (
            <Box className="portrait" pb={3}>
              {useGatsbyImage ? (
                <GatsbyImage image={image} alt={name} />
              ) : (
                <StyledImage blurLoad minSize="100x0" src={image} alt={name} />
              )}
            </Box>
          )}

          <Type as="h3" className="mb-3 font-foundersGrotesk text-p2">
            {name}
          </Type>

          <Type as="p" className="font-foundersGrotesk text-p3 font-light">
            {description}
          </Type>
        </Box>
      </Flex>
    </HoverLink>
  );
};

export default TeamMemberCard;
